<div class="container">
  <div class="button-group-container mt-4">
    <div class="btn-group" [(ngModel)]="radioModel" btnRadioGroup>
      <label class="btn btn-primary" [btnRadio]="'SINGLE'" tabindex="0" role="button">Regular</label>
      <label class="btn btn-primary" [btnRadio]="'COURSE'" tabindex="0" role="button">Course</label>
      <label class="btn btn-primary" [btnRadio]="'CAMP'" tabindex="0" role="button">Event</label>
    </div>
  </div>
  <form class="row row-cols-sm-auto">
    <div class="col-2">
      <label for="datepicker">Select Period</label>
      <div class="input-group">
        <div class="dp-hidden position-absolute">
          <input
            name="datepicker"
            id="datepicker"
            class="form-control"
            ngbDatepicker
            #datepicker="ngbDatepicker"
            [autoClose]="false"
            (dateSelect)="onDateSelection($event)"
            [displayMonths]="2"
            [dayTemplate]="dayTemplate"
            [footerTemplate]="footerTemplate"
            [markDisabled]="markDisabled"
            outsideDays="hidden"
            [startDate]="fromDate!"
            tabindex="-1"
          />
          <ng-template #dayTemplate let-date let-focused="focused">
          <span
            class="custom-day"
            [class.focused]="focused"
            [class.range]="isRange(date) && !isDisabled(date)"
            [class.faded]="
              (isHovered(date) || isInside(date)) && !isDisabled(date)
            "
            [class.disabled-day]="isDisabled(date)"
            (mouseenter)="hoveredDate = date"
            (mouseleave)="hoveredDate = null"
          >
            {{ date.day }}
          </span>
          </ng-template>
          <ng-template #footerTemplate>
            <div class="calendar-footer">
              <button
                class="btn btn-outline-danger btn-sm"
                (click)="clearSelection()"
              >
                Clear Selection
              </button>
              <button
                class="btn btn-outline-primary btn-sm"
                (click)="refreshSchedules()"
              >
                Select Period
              </button>
            </div>
          </ng-template>
        </div>
      </div>
      <div class="input-group">
        <input
          #dpFromDate
          class="form-control"
          name="dpFromDate"
          [value]="getFromToDate(fromDate, toDate)"
          (input)="fromDate = validateInput(fromDate, dpFromDate.value)"
          (click)="datepicker.toggle()"
        />
      </div>
    </div>
    <div class="col-2">
      <form [formGroup]="teachersFormGroup">
        <div class="form-row">
            <label for="teacherId">Select teacher:</label>
            <select id="teacherId" class="form-control" formControlName="teacherId">
              <option *ngFor="let teacher of teachers"
                      [value]="teacher.id">
                {{ teacher.firstName + ' ' + teacher.lastName }}
              </option>
            </select>
        </div>
      </form>
    </div>
    <div class="col-2" *ngIf="radioModel === 'COURSE'">
      <form [formGroup]="bundlesFormGroup">
        <div class="form-row">
            <label for="bundleId">Select Course:</label>
            <select id="bundleId" class="form-control" formControlName="bundleId">
              <option *ngFor="let course of courses"
                      [value]="course.id">
                {{ course.name }}
              </option>
            </select>
        </div>
      </form>
    </div>
    <div class="col-2" *ngIf="radioModel !== 'CAMP'">
      <form [formGroup]="schedulesFormGroup">
        <div class="form-row">
            <label for="scheduleId">Select Lesson:</label>
            <select id="scheduleId" class="form-control" formControlName="scheduleId">
              <option *ngFor="let schedule of schedules"
                      [value]="schedule.id">
                {{ schedule.name }}
              </option>
            </select>
        </div>
      </form>
    </div>
    <div class="text-center col-2 d-flex align-items-end">
      <button
        type="button"
        class="btn btn-default add-button"
        (click)="openAddBookingModal()"
      >
        <i class="fas fa-plus"></i> Add booked lesson
      </button>
    </div>
  </form>
  <div class="user-list mt-3 mb-3 table-responsive">
    <table class="table table-responsive-lg table-hover">
      <thead>
      <tr>
        <th class="text-center" scope="col">Lesson Date</th>
        <th class="text-center" scope="col">Lesson Name</th>
        <th class="text-center" scope="col">Teacher's Name</th>
        <th class="text-center" scope="col">Registered Children</th>
        <th class="text-center" scope="col">Actions</th>
        <th class="text-center" scope="col"></th>
      </tr>
      </thead>
      <tbody>
      <ng-container *ngFor="let lesson of selectedLessons | paginate : {
                  itemsPerPage: pageSize,
                  currentPage: pageNumber,
                  totalItems: totalElements
                };
          let i = index">
        <!-- Main row -->
        <tr (click)="toggleRow(i)" style="cursor: pointer;">
          <td class="text-center">{{ lesson.bookingDate }}</td>
          <td class="text-center">{{ lesson.name }}</td>
          <td class="text-center">
            {{ lesson.teacherFirstName }} {{ lesson.teacherLastName }}
          </td>
          <td class="text-center">
            <div class="children-with-details">
              <span>{{ lesson.participantsInfo.length }}</span>
            </div>
          </td>
          <td class="text-center">
            <div class="actions-container">
              <i class="fas fa-cancel cancel-button" role="button" (click)="cancelLesson($event, lesson)"></i>
              <i class="fas fa-edit cancel-button" role="button" (click)="rescheduleLesson($event, lesson)"></i>
            </div>
          </td>
          <td class="text-center">
            <i [class]="'fas' + (expandedRowIndex === i ? ' fa-chevron-up' : ' fa-chevron-down')"></i>
          </td>
        </tr>
        <!-- Collapsible row -->
        <tr *ngIf="expandedRowIndex === i" style="background-color: #fafafa;">
          <td colspan="6">
            <div class="table-responsive" *ngIf="lesson.participantsInfo?.length > 0; else noParticipants">
              <table class="table table-bordered table-sm">
                <thead>
                <tr>
                  <th scope="col" class="text-center">Date</th>
                  <th scope="col" class="text-center">Child Name</th>
                  <th scope="col" class="text-center">Child Age</th>
                  <th scope="col" class="text-center">Parent Name</th>
                  <th scope="col" class="text-center">Parent Phone</th>
                  <th scope="col" class="text-center">Parent Email</th>
                  <th scope="col" class="text-center">Actions</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let participant of lesson.participantsInfo">
                  <td class="text-center">
                    {{participant.bookingDate}}
                  </td>
                  <td class="text-center">
                    {{participant.childFirstName}} {{participant.childLastName}}
                  </td>
                  <td class="text-center">
                    {{participant.childAge}}
                  </td>
                  <td class="text-center">
                    {{participant.parentFirstName}} {{participant.parentLastName}}
                  </td>
                  <td class="text-center">
                    <a href="tel:{{participant.parentPhone}}">{{participant.parentPhone}}</a>
                  </td>
                  <td class="text-center">
                    <a href="mailto:{{participant.parentEmail}}">{{participant.parentEmail}}</a>
                  </td>
                  <td class="text-center">
                    <div class="actions-container">
                      <i class="fas fa-cancel cancel-button" role="button" (click)="cancelLesson($event, participant)"></i>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <ng-template #noParticipants>
              <div>

              </div>
            </ng-template>
          </td>
        </tr>
      </ng-container>
      </tbody>
    </table>
  </div>
  <div *ngIf="totalElements > 0" class="row justify-content-center">
    <div class="col-md-auto">
      <pagination-controls
        previousLabel="Prev"
        nextLabel="Next"
        responsive="true"
        (pageChange)="handlePageChange($event)"></pagination-controls>
    </div>
    <!--<div class="col-md-auto">
      Items per page:
      <select (change)="handlePageSizeChange($event)">
        <option *ngFor="let size of pageSizes" [ngValue]="size">
          {{ size }}
        </option>
      </select>
    </div>
    <div class="col-md-auto">
      <div>{{ getMinLimit() }}-{{ getMaxLimit() }} of {{ totalElements }} items</div>
    </div>-->
  </div>
  <div class="form-row mt-4">
    <div class="alert alert-danger" *ngIf="errorMessage">Error: {{ errorMessage }}</div>
  </div>
</div>
